import validator from 'validator';
import { empty} from 'utils/validators';
import {translate} from 'utils/common';

class FormValidator {
  constructor(validations) {
    // validations is an array of rules specific to a form
    this.validations = validations;
  }
  validate(state, stateKey) {
    const derivedState = stateKey? {...state[stateKey]}: {...state};
    // start out assuming valid
    let validation = this.valid();
    // for each validation rule
    this.validations.forEach(rule => {
      let field = rule.aliasField || rule.field;
      // if the field isn't already marked invalid by an earlier rule
      if (!rule.disabled && !validation[field].isInvalid) { 
        // determine the field value, the method to invoke and
        // optional args from the rule definition
        let field_value;
        if(field && field.includes('.')) {
          field_value = (field.split('.').reduce((o,i)=>o[i], derivedState) || '').toString();
        } else if(rule.allowZeroValue){
          field_value = ((derivedState[field]+'') || '').toString();
        }else {
          field_value = (derivedState[field] || '').toString();
        }
        const args = rule.args || [];
        const validation_method = this.getMethod(rule.method);
        let isValidationMethodActivated = this.getIsValidationMethodActivated(rule, field_value, args, derivedState);
        
        // call the validation_method with the current field value
        // as the first argument, any additional arguments, and the
        // whole derivedState as a final argument.  If the result doesn't
        // match the rule.validWhen property, then modify the
        // validation object for the field and set the isValid
        // field to false

        // validation method can also return the message in certain scenarios where there is inter dependent fields
        let isInvalid, message;
        if(rule.methodHasMessage) {
            // validation method should return result in the format {isValid:true/false,message:''}
            const currentValidation = validation_method(field_value, ...args, derivedState)
            isInvalid = currentValidation.isValid != rule.validWhen;
            message = currentValidation.message;
        } else {
            isInvalid = validation_method(field_value, ...args, derivedState) != rule.validWhen;
            message = rule.message;
        }

        if(isValidationMethodActivated && isInvalid) {
          validation[field] = { 
            isInvalid: true, 
            message: this.getMessage(message)
          }
          validation.isValid = false;
        }
      }
    });
    return validation;
  }

  getIsValidationMethodActivated(rule, field_value, args, derivedState) {
    if(rule.activationMethod) {
      const validatorActivationMethod = this.getMethod(rule.activationMethod);
      return validatorActivationMethod(field_value, ...args, derivedState) === rule.activateWhen;
    }
    // validation method is always activated if there is no activation method defined.
    return true;
  }

  getMethod(method) {
    if(typeof method === 'string') {
      return validator[method];
    } else {
      return method;
    }

  }
  getMessage(message){
	  if(typeof message === 'string') {
		  return message;
	  }else{
		  return message();
	  }
  }
  enableDisableRules(fields,disabled){
    this.validations.forEach(rule => {
        rule.disabled = fields.includes(rule.field)?disabled:!!rule.disabled;
    });
  }
  // create a validation object for a valid form
  valid() {
    const validation = {}
    
    this.validations.map(rule => (
        validation[rule.aliasField || rule.field] = { isInvalid: false, message: '' }
    ));
    return { isValid: true, ...validation };
  }

  getValidationMap(data, fieldSpec){
    let returnArr=[];
    fieldSpec.map(fieldArr=>{
      fieldArr.map(field=>{
        let validateArr=[]; 
        if(field.name){
          ///onoffswitch not need required validation message
          if(field.required && field.fieldtype != "onoffswitch"){
            let validateMap = {
                field: field.name, 
                method: empty,
                validWhen: false,
                message: translate('required.error').replace('{0}', field.label)
            }
            validateArr.push(validateMap)
          }
          if(field.maxChar){
            let maxCharMap = {
              field: field.name, 
              method: "isLength",
              validWhen: true,
              args:[{max: field.maxChar}],
              message: translate('maxchar.error').replace('{0}', field.maxChar) 
            }
            validateArr.push(maxCharMap)
          }
        }
        returnArr=[...returnArr, ...validateArr]
      })
    })
    return returnArr;
  }

  // getValidationMap2(data,fieldArr){
  //   let returnArr=[];
  //   fieldArr.map(field=>{
  //     let validateArr=[];      
  //     if (field.dataPath && field.dataPath.includes('.')) {
  //       var data2;
  //       let keyPath = field.dataPath.split('.')
  //       let lastKeyIndex = keyPath.length-1;
  //       for (var i = 0; i < lastKeyIndex; ++ i) {
  //         let key = keyPath[i];
  //         if (!(key in data))
  //           data[key] = {}
  //         data2 = data[key];
  //       }
  //       let dataItem = data2[keyPath[lastKeyIndex]];
  //       if(!dataItem || !dataItem.validation) return;
  //       if(dataItem.validation && dataItem.validation.required){
  //         let validateMap = {
  //             field: field.fieldName, 
  //             method: empty,
  //             validWhen: false,
  //             message: translate('seller.up_field_required').replace('{0}', dataItem.title)
  //         }
  //         validateArr.push(validateMap)
  //       }
  //     }
  //     else if(field.dataPath){
  //       let dataItem = data[field.dataPath];
  //       if(!dataItem || !dataItem.validation) return;
  //       if(dataItem.validation && dataItem.validation.required){
  //         let validateMap = {
  //           field: field.fieldName, 
  //           method: empty,
  //           validWhen: false,
  //           message: translate('seller.up_field_required').replace('{0}', dataItem.title)
  //       }
  //       validateArr.push(validateMap)
  //       }
  //     }
  //     returnArr=[...returnArr, ...validateArr]
  //   })
  //   return returnArr;
  // }
  getValidationMap_leagacy(data,fieldArr){
    let returnArr=[]
    fieldArr.forEach(field=>{
        let validateArr=[];
        let dataItem = data[field];
        if(!dataItem || !dataItem.validation) return;
        if(dataItem.validation && dataItem.validation.mandatory){
          let validateMap = {
              field: field+".value", 
              method: empty,
              validWhen: false,
              message: translate('seller.up_field_required').replace('{0}', dataItem.displayName)
          }
          validateArr.push(validateMap)
        }
        if(dataItem.validation.length){
          let validateMap = {
            field: field+".value",
          	method: 'isLength',
            validWhen: true,
            args:[{max:dataItem.validation.length}],
          	message: translate('seller.up_required_length_error').replace('{0}', dataItem.displayName).replace('{1}', dataItem.validation.length)
          }
          validateArr.push(validateMap)
        }
        // else if(dataItem.validation.maxlength){
        //   let validateMap = {
        //     field: field+".value",
        //   	method: 'isLength',
        //     validWhen: true,
        //     args:[{max:dataItem.validation.maxlength}],
        //   	message: translate('seller.up_'+field+'_maxlimit').replace('{0}', dataItem.displayName).replace('{1}', dataItem.validation.length)
        //   }
        //   validateArr.push(validateMap)
        // } 
        returnArr=[...returnArr, ...validateArr]
    })
    return returnArr;
  }
}
export default FormValidator;
